export default function register(state = {}, action) {
  switch (action.type) {
    case 'register_SUCCESS':
      return {...state, user: action.payload.data, error: null };
    case 'register_FAIL':
      return { ...state, user: null, error: action.error.response.data};

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./client/reducers/register.js